enum ActionTypes {
  // PHOTOS
  GET_PHOTOS = 'gfm/photos/GET_PHOTOS',
  SET_PHOTOS = 'gfm/photos/SET_PHOTOS',
  GET_PHOTOS_COUNT = 'gfm/photos/GET_PHOTOS_COUNT',
  SET_PHOTOS_COUNT = 'gfm/photos/SET_PHOTOS_COUNT',
  GET_EXCEL_PHOTOS = 'gfm/photos/GET_EXCEL_PHOTOS',
  GET_PHOTOS_REQUEST = 'gfm/photos/GET_PHOTOS_REQUEST',
  GET_ALUMNS_VALIDATIONPHOTOS_REQUEST = 'gfm/photos/GET_ALUMNS_VALIDATIONPHOTOS_REQUEST',
  SET_ALUMNS_VALIDATIONPHOTOS = 'gfm/photos/SET_ALUMNS_VALIDATIONPHOTOS',
  SET_GET_ALUMNS_VALIDATIONPHOTOS_REQUEST_STATUS = 'gfm/photos/SET_GET_ALUMNS_VALIDATIONPHOTOS_REQUEST_STATUS',
  REMOVE_PHOTOS_FILTER = 'gfm/photos/REMOVE_PHOTOS_FILTER',
  POST_PHOTO_VALID_SELECTION = 'gfm/photos/POST_PHOTO_VALID_SELECTION',
  POST_PHOTO_REJECT_SELECTION = 'gfm/photos/POST_PHOTO_REJECT_SELECTION',
  SET_POST_PHOTO_REJECT_REQUEST_STATUS = 'gfm/photos/SET_POST_PHOTO_REJECT_REQUEST_STATUS',
  SET_POST_PHOTO_VALID_REQUEST_STATUS = 'gfm/photos/SET_POST_PHOTO_VALID_REQUEST_STATUS',
}

export default ActionTypes;
